import { SimulationNodeDatum } from 'd3-force'
import { observable, action, computed } from 'mobx'
import { INode, IProps, IStyle, NODE_STYLE } from '../../store/graph/types'

class GNode implements SimulationNodeDatum {
    public id: string
    @observable public name: string
    @observable public visible: boolean = true
    @observable public selected: boolean = false
    @observable public highlight: boolean = false
    public index?: number
    @observable public x: number
    @observable public y: number
    public vx?: number
    public vy?: number
    public fx?: number | null
    public fy?: number | null
    public move_statr_x: number = 0
    public move_statr_y: number = 0
    public isFixed: boolean = false
    public style: IStyle

    @computed public get num_id() {
        return parseInt(this.id, 10)
    }

    public labels: string[] = []
    public props: IProps

    constructor(node: INode) {
        this.id = `${node.id}`
        this.name = node.props.name
        this.labels = node.labels
        this.props = node.props
        this.x = node.x
        this.y = node.y
        this.visible = node.visible || true
        if ('HONGKONGEXCHANGESANDCLEARINGLIMITED' === node.props.upper_name) {
            node.props.hkex = true
            this.style = NODE_STYLE.HKEX
        } else if (node.props.hkex_group) {
            this.style = NODE_STYLE.PARTA
        } else {
            this.style = NODE_STYLE.DEFAULT
        }
    }

    @action
    public setX(x: number) {
        this.x = x
    }

    @action
    public setY(y: number) {
        this.y = y
    }
}
export default GNode
